import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import {
  Box,
  Chip,
  Table,
  Paper,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Typography,
  TableContainer,
} from "@mui/material";

import Title from "../../../common/Title";
import ApiLogHistory from "../../../common/ApiLogHistory";

import useAxios from "../../../../hooks/useAxios";
import { __getChangePlanLog } from "../../../../api/sim";
import { getChipColor } from "../../../../constants/value";

const ChangePlanHistory = (props) => {
  const [changePlanHistory, setChangePlanHistory] = useState([]);
  const { change_plan_id } = useParams();

  const [response, call, loading] = useAxios({
    ...__getChangePlanLog(change_plan_id),
  });

  useEffect(() => {
    if (response && response.status) {
      setChangePlanHistory(response.data);
    }
  }, [response]);

  useEffect(() => {
    call();
  }, []);

  return loading ? (
    <Title content="Please wait..." variant="subtitle2" gutterBottom />
  ) : (
    <>
      <Box mb={2} pt={2}>
        <Typography variant="h5" align="left">
          Change Plan Log
        </Typography>
      </Box>

      {response && changePlanHistory.data ? (
        <>
          <Box
            sx={{ width: "100%", mb: 5 }}
            display="flex"
            alignItems="center"
            flexDirection="column"
          >
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">MDN</TableCell>
                    <TableCell align="left">Batch ID</TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="left">New Plan ID</TableCell>
                    <TableCell align="left">Last Updated</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="left">
                      {changePlanHistory.data.iccid}
                    </TableCell>
                    <TableCell align="left">
                      <Link
                        underline="none"
                        to={`/pwg/change_plan/batch/${changePlanHistory.data.batch_id}`}
                      >
                        {changePlanHistory.data.batch_id}
                      </Link>
                    </TableCell>
                    <TableCell align="left">
                      <Chip
                        label={changePlanHistory.data.status}
                        size="small"
                        color={getChipColor(changePlanHistory.data.status)}
                      />
                    </TableCell>
                    <TableCell align="left">
                      {changePlanHistory.data.plan_id}
                    </TableCell>
                    <TableCell align="left">
                      {changePlanHistory.data.last_updated &&
                        `${format(
                          new Date(changePlanHistory.data.last_updated),
                          "MMMM d, y hh:mm a"
                        )}`}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <ApiLogHistory data={changePlanHistory.history.data} />
        </>
      ) : (
        <Box mb={2} pt={2}>
          <Typography variant="h5" align="left">
            No Data
          </Typography>
        </Box>
      )}
    </>
  );
};

export default ChangePlanHistory;
